import React from 'react';
import * as theme from '../../../theme';
import Heading from '../../../components/Heading';
import AfterTheScanImage from './images/AfterTheScan.png';

function AfterTheScan({ title }) {
  const listStyle = {
    paddingLeft: 20,
    marginTop: 7,
    marginBottom: 20,
  };

  const listItemStyle = {
    marginLeft: 10,
    marginBottom: 8,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 800, position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
      <Heading
        title={title}
        subHeading={true}
        center={true}
      />
      <div style={{ ...theme.SubText, position: 'relative', marginRight: 'auto', marginLeft: 'auto' }}>
        Once a scan is complete, the scan reports and findings for your client will be available on the specific Scan Details page within the TruBalance Bioenergetics app. The reports are organized into two sections: <strong>Client Report</strong> and <strong>Scan Reports</strong>.<br /><br />

        <strong>Client Report</strong><br />
        The <strong>Client Report</strong> is the only report intended for sharing with your client. This concise, client-friendly PDF can be downloaded from the app and shared via your preferred method (e.g., email or secure messaging). It provides a clear summary of the scan results tailored for the client.<br /><br />

        <strong>Scan Reports</strong><br />
        The <strong>Scan Reports</strong> section contains additional detailed reports designed exclusively for you, the practitioner, to develop a personalized healing protocol for your client. <strong>These reports are not meant to be shared with the client</strong> and should remain confidential. You can access these reports directly in the app or download them as PDFs for your records.<br /><br />

        The Scan Reports include:<br />
        <ul style={listStyle}>
          <li style={listItemStyle}><strong>Supplement (Detail)</strong>: In-depth supplement recommendations.</li>
          <li style={listItemStyle}><strong>Supplement (Shortened)</strong>: Less detailed version of the Supplement report showing in order of homeopathic dilutions.</li>
          <li style={listItemStyle}><strong>Root Cause</strong>: Insights into underlying root cause issues identified in the scan.</li>
          <li style={listItemStyle}><strong>Emotions</strong>: Emotional factors influencing the client’s well-being (homeopathically based).</li>
          <li style={listItemStyle}><strong>Focus Scans</strong>: Targeted analysis based on scan priorities and practitioner requests.</li>
        </ul>

        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', marginTop: 10, alignItems: 'center' }}>
          <div style={{ marginBottom: 7 }}>EXAMPLE</div>
          <img style={{ width: window.innerWidth > 1000 ? 360 : '100%', maxWidth: 360, border: '5px solid ' + theme.Colors.GoldDark }} src={AfterTheScanImage} alt="List of Reports" /><br /><br />
        </div>

        By using the Client Report for client communication and leveraging the Scan Reports for your protocol development, you can ensure clear, professional interactions while maintaining the confidentiality of detailed practitioner insights.<br /><br />

        <strong>Imprint Remedy</strong><br />
        We will mail the <strong>Imprint Remedy</strong> kit directly to your client, including detailed instructions on usage and dosing (refer to the Imprint Remedy training content for more information). No action is required from you; our team will handle the preparation and shipping of the kit. You will only need to address any direct questions your client may have about the remedy.
      </div>
    </div>
  );
}

export default AfterTheScan;